import Link from 'next/link'

const GoBackLink = ({ url }) => (
  <Link href={url} className="flex items-center">
    <img src="/assets/icons/arrow-mini-left.svg" alt="left" className="mr-3 " />
    <span>Enrere</span>
  </Link>
)

const GoBackAction = ({ action }) => (
  <button onClick={action} className="flex items-center">
    <img src="/assets/icons/arrow-mini-left.svg" alt="left" className="mr-3 " />
    <span>Enrere</span>
  </button>
)

export { GoBackLink, GoBackAction }
